import { useEffect, useMemo } from "react";
import {
  useGLTF,
  useAnimations,
  useMatcapTexture,
  useTexture,
} from "@react-three/drei";
import * as THREE from "three";

export default function CaiLogo(props) {
  const cai = useGLTF("./models/caiLogoAnimated.glb");
  const { nodes } = useGLTF("./models/caiLogoAnimated.glb");
  // console.log(nodes.cai.geometry);
  const animations = useAnimations(cai.animations, cai.scene);
  // find out what is the animationName
  // const { animationName1 } = useControls("KeyAction", {
  //   animationName: { options: animations.names },
  // });
  const animationName = "KeyAction.001";
  useEffect(() => {
    const action = animations.actions[animationName];
    action.reset().fadeIn(0.5).play();
    return () => {
      action.fadeOut(0.5).stop();
    };
  }, [animationName, animations.actions]);

  const LogoMaterial = useMemo(
    () =>
      new THREE.MeshMatcapMaterial({
        side: THREE.DoubleSide,
        flatShading: true,
      }),
    [],
  );

  const matcapTexture = useTexture(
    "/textures/7877EE_D87FC5_75D9C7_1C78C0-128px.png",
  );

  cai.scene.traverse((child) => {
    if (child.isMesh) {
      child.material = LogoMaterial;
      child.castShadow = true;
    }
  });
  useEffect(() => {
    LogoMaterial.matcap = matcapTexture;
    // Assigning .matcap does not bump the material version; without this the
    // shader keeps its no-matcap variant if the first draw happened before
    // the texture finished loading (scene renders immediately now).
    LogoMaterial.needsUpdate = true;
  }, [LogoMaterial, matcapTexture]);
  return (
    <primitive
      {...props}
      object={cai.scene}
      // scale={1}
      // position={[0, 0, 0]}
      // rotation={[0, 0, 0]}
      // NOTE: no material prop here. It would set .material on the GLTF
      // root Group, which makes renderer.compile() throw on the whole scene
      // (Groups have no geometry). The traverse above assigns the material
      // to each mesh already.
    ></primitive>
  );
}
useGLTF.preload("./models/caiLogoAnimated.glb");
